import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { DatePicker, TimePicker } from 'antd';
import moment from 'moment';
// import 'moment/locale/uk';

class DateField extends Component {
  constructor(props) {
    super(props)
  }

  componentWillMount() {

  }

  componentDidMount() {

  }

  componentWillReceiveProps(nextProps) {

  }

  componentWillUnmount() {

  }


  onChangeTime = (value) => {
    
    if(this.props.onHandleChange){
      this.props.onHandleChange(value, this.props.input)
    } else {
      if(this.props.input.onChange){
        this.props.input.onChange(value);
      }
    }
  }

  render() {
    let {input, placeholder, inputProps, inputPropsTime, label, meta: { touched, error }} = this.props; 


    return (
      <div className="form__form-group">
        {label ? <span className="form__form-group-label">{label}</span> : null}
        <div className="form__form-group-field">
          <div className="form__form-group-input-wrap">
            <div style={{display: 'flex', flexDirection: 'row'}}>
              <div style={{display: 'flex', flex: 'auto', marginRight: '20px',}}>
                <DatePicker
                  value={input.value && moment(input.value).isValid() ? moment(input.value) : undefined}
                  placeholder=''
                  style={{width: '100%'}}
                  allowClear={false}
                  onChange={this.onChangeTime}
                  format='DD-MM-YYYY'
                  showToday={false}
                  {...inputProps}
                />
              </div>
              <div style={{display: 'flex'}}>
                <TimePicker 
                  onChange={this.onChangeTime} 
                  value={input.value && moment(input.value).isValid() ? moment(input.value) : undefined} 
                  {...inputPropsTime}
                />
              </div>
            </div>
            
            {touched && error && <span className="form__form-group-error">{error}</span>}
          </div>
        </div>
      </div>
    )
  }
}

DateField.propTypes = {

}

export default DateField


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/helpers/Fields/DateField.jsx